module.exports = __webpack_public_path__ + "img/Logo_Chat.8a040211.svg";